import { Component } from '@angular/core';

@Component({
  selector: 'app-player-button',
  standalone: true,
  imports: [],
  templateUrl: './player-button.component.html',
  styleUrl: './player-button.component.scss'
})
export class PlayerButtonComponent {

}
